import { DataService } from "./DataService.js";

export class ChunkDataService extends DataService {
    //interface for indexeddb and http services


    //here
    getMergedChunkForIDList(idList) {
        
    }

    isWithCache() {
        return false;
    }
}